import { api } from './api';
import { Prediction } from '../types/prediction';

// Add type definitions for ApiResponse and Product
export interface ApiResponse<T> {
  status: number;
  message: string;
  data: T;
}

export interface Product {
  id: number;
  name: string;
  description: string;
  category: string;
  logo: string;
  infoUrl: string;
  attributes: {
    icon: string;
  };
  // add other fields as needed
}

export interface PredictionsResponse {
  predictions: Prediction[];
  total: number;
}

interface FilterParams {
  productId?: string;
  status?: string;
  date?: string;
  search?: string;
  page?: number;
  limit?: number;
}

export const predictionsApi = {
  getUserPredictions: async (userId: string, filters?: FilterParams): Promise<ApiResponse<PredictionsResponse>> => {
    try {
      const queryParams = new URLSearchParams();
      if (filters?.productId) queryParams.append('productId', filters.productId);
      if (filters?.status) queryParams.append('status', filters.status);
      if (filters?.date) queryParams.append('date', filters.date);
      if (filters?.search) queryParams.append('search', filters.search);
      if (filters?.page) queryParams.append('page', filters.page.toString());
      if (filters?.limit) queryParams.append('limit', filters.limit.toString());

      const url = `/predictions/userPredictions/${userId}${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching user predictions:', error);
      throw error;
    }
  },

  getPredictionDetails: async (id: string): Promise<Prediction> => {
    const response = await api.get(`/predictions/${id}`);
    return response.data;
  },

  createPrediction: async (data: Partial<Prediction>): Promise<Prediction> => {
    const response = await api.post('/predictions', data);
    return response.data;
  },

  confirmPrediction: async (id: string, applicationDate: string): Promise<Prediction> => {
    const response = await api.post(`/predictions/confirm-prediction/${id}`, {
      confirmationDate: applicationDate
    });
    return response.data;
  },

  getProducts: async () => {
    const response = await api.get('/products');
    return response.data;
  },

  getProductDetails: async (id: number): Promise<ApiResponse<Product>> => {
    const response = await api.get(`/products/${id}`);
    return response.data;
  }
}; 